import { AfterContentInit, Component, ContentChild, EventEmitter, HostBinding, Input, Output } from '@angular/core';
import { NgControl, Validators } from '@angular/forms';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';

@UntilDestroy()
@Component({
  selector: 'vnm-form-field',
  templateUrl: './form-field.component.html',
  styleUrls: ['./form-field.component.scss']
})
export class FormFieldComponent implements AfterContentInit {
  @HostBinding('class.p-field') uiField = true;
  @ContentChild(NgControl) formControl: NgControl;

  requiredField = false;

  // The main label for the field (required)
  @Input() label: string;

  // Extra explanation to show with the label
  @Input() info: string;

  // Even more help explanation to show with a tooltip and icon
  @Input() help: string;

  @Output() tooltipClicked = new EventEmitter();

  ngAfterContentInit() {
    this.requiredField = this.formControl?.control?.hasValidator(Validators.required);
    this.formControl?.statusChanges?.pipe(untilDestroyed(this)).subscribe((_) => {
      this.requiredField = this.formControl?.control?.hasValidator(Validators.required);
    });
  }
}
